import { Injectable, APP_INITIALIZER } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment'; 
import { throwError } from 'rxjs';

@Injectable()
export class ConfigService {

  private _config: Object
  private _env: string;

  constructor(private _http: HttpClient) { }
  load() {

    return new Promise((resolve, reject) => {
    
      if (environment.environmentName && environment.environmentName != undefined && environment.environmentName != '') {
        switch (environment.environmentName) {
          case 'staging':
            this._env = 'appconfig-staging';
            break;
          case 'dev':
            this._env = 'appconfig-dev';
            break;
          default:
            this._env = 'appconfig-prod';
            break;
        }
      }
      else {
        if (environment.production)
          this._env = 'appconfig-prod';
        else
          this._env = 'appconfig-dev';
      }
   
      this._http.get('./assets/config/' + this._env + '.json')
        .subscribe((data) => {
          this._config = data;
          resolve(true);
        },
          (error: any) => {
            console.error(error);
            return throwError(error.json().error || 'Server error');
          });
    });
  }
  // Is app in the development mode?
  isDevmode() {
    return this._env === 'development';
  }
  // Gets API route based on the provided key
  getAppApi(key: string): string {

    return this._config["API_CONFIG"]["API_ENDPOINTS"]["APP_ENDPOINTS"][key];
  }
  getAppApiUrl(key: string): string {

    return this._config["API_CONFIG"]["API_SETTINGS"]["APP_BASE"] + this.getAppApi(key);
  }

  getEnviromentId(){
    switch (this._env) {
          case 'appconfig-dev':
            return 0;
            break;
          case 'appconfig-staging':
            return 1;
            break;
          default:
            return 2;
            break;
        }
  }

  get(key: any) {
    return this._config[key];
  }

}

export function ConfigFactory(config: ConfigService) {
  return () => config.load();
}

export function init() {
  return {
    provide: APP_INITIALIZER,
    useFactory: ConfigFactory,
    deps: [ConfigService],
    multi: true
  }
}

const ConfigModule = {
  init: init
}

export { ConfigModule };
